import { createReducer } from '@reduxjs/toolkit'

import { selectPercent, setSlippageTolerance } from './actions'

export interface BurnCharmState {
  readonly percent: number
  readonly slippageTolerance: number // percentage for amount0Min/amount1Min
}

const initialState: BurnCharmState = {
  percent: 0,
  slippageTolerance: 0.5, // 0.5% default slippage
}

export default createReducer<BurnCharmState>(initialState, (builder) =>
  builder
    .addCase(selectPercent, (state, { payload: { percent } }) => {
      return {
        ...state,
        percent,
      }
    })
    .addCase(setSlippageTolerance, (state, { payload: { slippageTolerance } }) => {
      return {
        ...state,
        slippageTolerance,
      }
    })
)
